import * as React from 'react';
import { useTranslation } from '@lib/useTypedTranslation';
import { useState } from 'react';
import moment from 'moment';

import ThresholdSettingsWithPeriod from '../thresholdSettingsWithPeriod';
import { WorldSettings } from '../../../../services/config/config';

import '../settings.css';

export interface IProps {
  worldSettings: WorldSettings,
  submitInProgress: boolean,
  timeStamp: number,
  onDataChanged: (data: WorldSettings) => void
}

export function DropSettings(props: IProps) {
  const { t } = useTranslation('settings');
  const [alertTimeStamp, setAlertTimeStamp] = useState<number>(props.timeStamp);

  if (props.timeStamp > alertTimeStamp) {
    setAlertTimeStamp(props.timeStamp);
  }

  function onDataChanged(data: number, field?: string) {
    if (field === 'warning') {
      props.onDataChanged({ ...props.worldSettings, deviceUserExperienceDropStatusYellow: data });
    } else if (field === 'problem') {
      props.onDataChanged({ ...props.worldSettings, deviceUserExperienceDropStatusRed: data });
    } else {
      props.onDataChanged({ ...props.worldSettings, deviceUserExperienceDropStatusPeriod: data });
    }
  }

  function onAlertToggled(data: boolean, initialSettings: { warning: number, problem: number, days: number }) {
    setAlertTimeStamp(moment.utc().valueOf());
    props.onDataChanged({
      ...props.worldSettings,
      deviceUserExperienceDropStatusEnabled: data,
      deviceUserExperienceDropStatusYellow: initialSettings.warning,
      deviceUserExperienceDropStatusRed: initialSettings.problem,
      deviceUserExperienceDropStatusPeriod: initialSettings.days
    });
  }

  return (
    <ThresholdSettingsWithPeriod
      key={alertTimeStamp}
      title={t('DROPS_TITLE')}
      message={'DROPS_MESSAGE'}
      popoverText={t('DROPS_POPOVER')}
      className="drops"
      days={props.worldSettings.deviceUserExperienceDropStatusPeriod}
      warning={props.worldSettings.deviceUserExperienceDropStatusYellow}
      problem={props.worldSettings.deviceUserExperienceDropStatusRed}
      dataUpdated={onDataChanged}
      disabled={props.submitInProgress || !props.worldSettings.deviceUserExperienceDropStatusEnabled}
      alertEnabled={props.worldSettings.deviceUserExperienceDropStatusEnabled}
      alertToggled={onAlertToggled}
    />
  );
}
